import { Box, Container, Stack } from '@mui/material';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { PoolRow, PoolTypography } from '@synergy/components-next';
import { ReactElement, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { NewsCard } from '../../../components/news-card/news-card';
import { PoolPageHeader } from '../../../components/page-header/page-header';
import { PoolPagination } from '../../../components/pagination/pagination';
import { ROUTES } from '../../../utils/routes';
import { fetchNews } from '../../../store/news-actions';
import { groupByMonthAndYear } from '../../../utils/group-by-month-and-year';
import { newsSelector } from '../../../store/news-selectors';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

export const NewsPageOverview = (): ReactElement | null => {
    const { news, pages, page } = useAppSelector(newsSelector);
    const [searchParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const groupedNews = useMemo(() => groupByMonthAndYear(news), [news]);

    useEffect(() => {
        searchParams.set('limit', '100');
        dispatch(fetchNews(searchParams));
    }, [searchParams, dispatch]);

    return (
        <>
            <PoolPageHeader variant="grey">
                <FormattedMessage id="app.topNavigation.news" />
            </PoolPageHeader>
            <Container maxWidth="xl" sx={{ mt: { sm: 8, xs: 4 }, mb: { sm: 10, xs: 6 } }}>
                <Stack gap={{ sm: 8, xs: 6 }} mb={{ sm: 4, xs: 3 }}>
                    {groupedNews.map(newsItem => (
                        <Stack gap={{ sm: 2.5, xs: 2 }} key={newsItem.date.toISOString()}>
                            <PoolTypography variant="h4">
                                <FormattedDate value={newsItem.date} year="numeric" month="long" />
                            </PoolTypography>

                            <Box
                                display="grid"
                                gridTemplateColumns={{ sm: 'repeat(auto-fill, minmax(380px, 1fr))', xs: '1fr' }}
                                gap={2}
                            >
                                {newsItem.posts.map(newsPost => (
                                    <NewsCard
                                        key={newsPost.id}
                                        news={newsPost}
                                        href={ROUTES.news.detail.replace(':id', newsPost.id.toString())}
                                    />
                                ))}
                            </Box>
                        </Stack>
                    ))}
                </Stack>

                <PoolRow justifyContent="center">
                    <PoolPagination pages={pages} siblingCount={1} page={page} />
                </PoolRow>
            </Container>
        </>
    );
};
